export default __webpack_public_path__ + "static/media/searchicon.30467f1f.svg";